module.exports = __webpack_public_path__ + "img/shams.b54e79a1.jpg";